function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from 'classnames';
import React, { Children, PureComponent } from 'react';
import IconBottomNavigation from './IconBottomNavigation';
import NumberBottomNavigation from './NumberBottomNavigation';
import { AUTO_TRANSITION_INTERVAL, BASE_CAROUSEL_PROPTYPES, TRANSITION_TRIGGER_THRESHOLD, ANIMATION_DELAY, ANIMATION_MAP, MOBILE, TYPE_ICON } from '../constants';
import { getSlideItems, getTransition, getPreviousIndex, getNextIndex, getTouchDistance } from './utils';

var BaseCarousel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BaseCarousel, _PureComponent);

  function BaseCarousel(props) {
    var _this;

    _classCallCheck(this, BaseCarousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseCarousel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_queueNextItem", function (displayIndex) {
      var length = _this.props.children.length;

      _this.setState(function (_ref) {
        var prevDisplayIndex = _ref.displayIndex,
            prevTransition = _ref.transition;
        return {
          queuedDisplayIndex: displayIndex,
          transition: getTransition({
            prevTransition: prevTransition,
            prevDisplayIndex: prevDisplayIndex,
            displayIndex: displayIndex,
            totalItems: length
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_loadNextItem", function () {
      var transitionDuration = _this.props.transitionDuration;
      setTimeout(function () {
        _this.setState(function (_ref2) {
          var prevTransition = _ref2.transition,
              displayIndex = _ref2.queuedDisplayIndex;
          var onTransition = _this.props.onTransition;
          var transition = ANIMATION_MAP[prevTransition];

          if (onTransition) {
            onTransition(displayIndex);
          }

          return {
            displayIndex: displayIndex,
            transition: transition
          };
        });
      }, transitionDuration);
    });

    _defineProperty(_assertThisInitialized(_this), "_startAutoTransition", function (shouldAutoTransition) {
      if (shouldAutoTransition && !_this._autoTransition) {
        _this._autoTransition = setInterval(_this._goToNextIndex, AUTO_TRANSITION_INTERVAL);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_stopAutoTransition", function () {
      if (_this._autoTransition) {
        clearInterval(_this._autoTransition);
        delete _this._autoTransition;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_goToNextIndex", function () {
      var _this$props = _this.props,
          length = _this$props.children.length,
          isNotContinuous = _this$props.isNotContinuous,
          onNext = _this$props.onNext;

      if (onNext) {
        onNext();
      } else {
        _this.setState(getNextIndex.bind(null, length, !isNotContinuous));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_goToPreviousIndex", function () {
      var _this$props2 = _this.props,
          length = _this$props2.children.length,
          isNotContinuous = _this$props2.isNotContinuous,
          onPrevious = _this$props2.onPrevious;

      if (onPrevious) {
        onPrevious();
      } else {
        _this.setState(getPreviousIndex.bind(null, length, !isNotContinuous));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleNavigate", function (displayIndex) {
      _this._queueNextItem(displayIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchStart", function (_ref3) {
      var changedTouches = _ref3.changedTouches;

      _this.setState({
        touchPosition: changedTouches[0].clientX
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchMove", function (_ref4) {
      var changedTouches = _ref4.changedTouches;
      var touchPosition = _this.state.touchPosition;
      var _changedTouches$ = changedTouches[0],
          clientX = _changedTouches$.clientX,
          screenX = _changedTouches$.screenX;

      _this.setState({
        distance: getTouchDistance({
          clientX: clientX,
          screenX: screenX,
          touchPosition: touchPosition
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchEnd", function (_ref5) {
      var changedTouches = _ref5.changedTouches;
      var touchPosition = _this.state.touchPosition;
      var _this$props3 = _this.props,
          onSwipeRight = _this$props3.onSwipeRight,
          onSwipeLeft = _this$props3.onSwipeLeft;
      var clientX = changedTouches[0].clientX;
      var delta = clientX - touchPosition;

      _this.setState({
        transition: ANIMATION_MAP[MOBILE],
        distance: 0
      }); // If it's within an acceptable range, then snap back to original slide


      if (Math.abs(delta) < TRANSITION_TRIGGER_THRESHOLD) {
        return;
      }

      if (delta > 0) {
        _this._goToPreviousIndex();

        if (onSwipeLeft) {
          onSwipeLeft();
        }
      } else {
        _this._goToNextIndex();

        if (onSwipeRight) {
          onSwipeRight();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_getLeftNavigation", function () {
      var _this$props4 = _this.props,
          leftNavigationNode = _this$props4.leftNavigationNode,
          bottomNavigationType = _this$props4.bottomNavigationType;

      if (bottomNavigationType === TYPE_ICON) {
        return leftNavigationNode;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "_getRightNavigation", function () {
      var _this$props5 = _this.props,
          rightNavigationNode = _this$props5.rightNavigationNode,
          bottomNavigationType = _this$props5.bottomNavigationType;

      if (bottomNavigationType === TYPE_ICON) {
        return rightNavigationNode;
      }

      return null;
    });

    var inheritedDisplayIndex = props.inheritedDisplayIndex,
        initialDisplayIndex = props.initialDisplayIndex;
    _this.state = {
      touchPosition: 0,
      distance: 0,
      displayIndex: inheritedDisplayIndex || initialDisplayIndex || 0
    };
    return _this;
  }

  _createClass(BaseCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoTransition = this.props.autoTransition;

      this._startAutoTransition(autoTransition);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref6) {
      var _ref6$inheritedDispla = _ref6.inheritedDisplayIndex,
          inheritedDisplayIndex = _ref6$inheritedDispla === void 0 ? 0 : _ref6$inheritedDispla,
          autoTransition = _ref6.autoTransition;
      var prevInheritedIndex = this.props.inheritedDisplayIndex;

      if (inheritedDisplayIndex !== prevInheritedIndex) {
        this._queueNextItem(inheritedDisplayIndex);
      }

      if (autoTransition) {
        this._startAutoTransition(autoTransition);
      } else {
        this._stopAutoTransition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          displayIndex = _this$state.displayIndex,
          queuedDisplayIndex = _this$state.queuedDisplayIndex,
          transition = _this$state.transition;

      if (displayIndex !== queuedDisplayIndex && transition && transition !== ANIMATION_MAP[MOBILE]) {
        this._loadNextItem();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._stopAutoTransition();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          children = _this$props6.children,
          itemsPerSlide = _this$props6.itemsPerSlide,
          customNavigation = _this$props6.customNavigation,
          showNavigation = _this$props6.showNavigation,
          leftNavigationNode = _this$props6.leftNavigationNode,
          rightNavigationNode = _this$props6.rightNavigationNode,
          bottomNavigationType = _this$props6.bottomNavigationType,
          fixAspectRatio = _this$props6.fixAspectRatio,
          isNotContinuous = _this$props6.isNotContinuous,
          usesNewStyle = _this$props6.usesNewStyle,
          title = _this$props6.title;
      var _this$state2 = this.state,
          displayIndex = _this$state2.displayIndex,
          distance = _this$state2.distance,
          transition = _this$state2.transition;
      var componentChildren = Children.toArray(children);

      var _getSlideItems = getSlideItems(componentChildren, displayIndex, itemsPerSlide, isNotContinuous),
          onScreen = _getSlideItems.onScreen,
          offScreen = _getSlideItems.offScreen;

      var style = {
        transform: "translatex(".concat(distance, "px)")
      };
      var slideClassName = classnames(_defineProperty({
        'eds-carousel-slide--fixed-ratio': fixAspectRatio,
        'eds-align--center-horizontal': !fixAspectRatio,
        'eds-base-carousel__slide': usesNewStyle
      }, transition, transition));
      var navigation = null;
      var newStyleHeader = null;
      var bottomNavOptions = {
        'icons': IconBottomNavigation,
        'numbers': NumberBottomNavigation
      };
      var baseContentClassName = classnames('eds-base-carousel__content', {
        'eds-base-carousel__content--fixed-ratio': fixAspectRatio
      });
      var newStyleHeaderClassName = classnames('eds-l-mar-bot-8', {
        'eds-align--center-vertical eds-align--space-between': title,
        'eds-align--right': !title
      });

      if (showNavigation) {
        var NavComponent = bottomNavOptions[bottomNavigationType];
        navigation = React.createElement(NavComponent, {
          displayIndex: displayIndex,
          onClick: this._handleNavigate,
          totalItems: children.length,
          itemsPerSlide: itemsPerSlide,
          customNavigation: customNavigation,
          leftNavigation: leftNavigationNode,
          rightNavigation: rightNavigationNode
        });
      }

      if (usesNewStyle) {
        newStyleHeader = React.createElement("div", {
          className: newStyleHeaderClassName
        }, title, React.createElement("div", {
          className: "eds-align--center-vertical"
        }, this._getLeftNavigation(), this._getRightNavigation()));
      }

      return React.createElement("div", {
        className: "eds-base-carousel",
        onTouchStart: this._handleTouchStart,
        onTouchMove: this._handleTouchMove,
        onTouchEnd: this._handleTouchEnd
      }, React.createElement("div", {
        className: baseContentClassName
      }, newStyleHeader, React.createElement("div", {
        className: "eds-align--center-vertical eds-align--space-around"
      }, !usesNewStyle && this._getLeftNavigation(), React.createElement("div", {
        "aria-live": "polite",
        className: slideClassName,
        style: style
      }, onScreen), !usesNewStyle && this._getRightNavigation())), React.createElement("div", {
        className: "eds-is-hidden-accessible",
        "aria-live": "off"
      }, offScreen), React.createElement("div", {
        className: "eds-align--center"
      }, navigation));
    }
  }]);

  return BaseCarousel;
}(PureComponent);

_defineProperty(BaseCarousel, "propTypes", BASE_CAROUSEL_PROPTYPES);

_defineProperty(BaseCarousel, "defaultProps", {
  transitionDuration: ANIMATION_DELAY
});

export { BaseCarousel as default };